import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const ShipShortIcon: FC<IconProps> = ({ width = 40, height = 17, ...rest }) => (
  <Icon type="ShipShort" width={width} height={height} alt="ShipShortIcon" {...rest} ignoreRtl />
)
